module.exports = {
  pablitosCheckoutPromo: false
}
